export const updateAnswer = (payload?: any) => ({
    type: "@saga/UPDATE_ANSWER",
    payload
});

